// Reading a token's claims WITHOUT verifying it. Safe for exactly two jobs:
// the browser reading the session JWT the Stytch SDK already holds (expiry,
// routing), and a log line about a token that was just rejected. Never an
// authorization decision on a server: that is createStytchVerifier's.
//
// atob, not Buffer, so the same code runs in the browser, Node and Deno.

/** The payload of a JWT as an object, or null when it does not decode to one. */
export function unverifiedClaims(token: string): Record<string, unknown> | null {
  const segment = token.split(".")[1]
  if (!segment) return null
  try {
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/")
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0))
    const payload: unknown = JSON.parse(new TextDecoder().decode(bytes))
    return payload && typeof payload === "object" && !Array.isArray(payload)
      ? (payload as Record<string, unknown>)
      : null
  } catch {
    return null
  }
}
